// Fallback news data when APIs are not available
export const fallbackNews = [
  {
    id: 1,
    title: "Bitcoin Surges Past $50,000 as Institutional Adoption Grows",
    excerpt:
      "Bitcoin has reached a new milestone as institutional investors continue to show strong interest in cryptocurrency assets...",
    category: "Crypto",
    date: new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    image: "https://via.placeholder.com/400x250?text=Bitcoin+News",
    author: {
      name: "CryptoPanic",
      avatar: "https://via.placeholder.com/40x40?text=CP",
      role: "News Source",
    },
    readTime: "3 min read",
    likes: 342,
    url: "#",
    source: "CryptoPanic",
  },
  {
    id: 2,
    title: "Gold Prices Stabilize Amid Economic Uncertainty",
    excerpt:
      "Gold prices have shown resilience in the face of market volatility, with investors seeking safe-haven assets...",
    category: "Commodities",
    date: new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    image: "https://via.placeholder.com/400x250?text=Gold+News",
    author: {
      name: "Marketaux",
      avatar: "https://via.placeholder.com/40x40?text=MX",
      role: "Financial News",
    },
    readTime: "4 min read",
    likes: 189,
    url: "#",
    source: "Marketaux",
  },
  {
    id: 3,
    title: "Ethereum 2.0 Update Brings New Features to DeFi Ecosystem",
    excerpt:
      "The latest Ethereum update introduces significant improvements to transaction speed and gas efficiency...",
    category: "Crypto",
    date: new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    image: "https://via.placeholder.com/400x250?text=Ethereum+News",
    author: {
      name: "CryptoPanic",
      avatar: "https://via.placeholder.com/40x40?text=CP",
      role: "News Source",
    },
    readTime: "5 min read",
    likes: 267,
    url: "#",
    source: "CryptoPanic",
  },
  {
    id: 4,
    title: "Oil Prices React to Global Supply Chain Changes",
    excerpt:
      "Recent developments in global trade routes are impacting oil prices and commodity markets worldwide...",
    category: "Commodities",
    date: new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    image: "https://via.placeholder.com/400x250?text=Oil+News",
    author: {
      name: "Marketaux",
      avatar: "https://via.placeholder.com/40x40?text=MX",
      role: "Financial News",
    },
    readTime: "6 min read",
    likes: 156,
    url: "#",
    source: "Marketaux",
  },
  {
    id: 5,
    title: "Solana Network Achieves Record Transaction Volume",
    excerpt:
      "Solana's blockchain network has processed unprecedented transaction volumes, showcasing its scalability...",
    category: "Crypto",
    date: new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    image: "https://via.placeholder.com/400x250?text=Solana+News",
    author: {
      name: "CryptoPanic",
      avatar: "https://via.placeholder.com/40x40?text=CP",
      role: "News Source",
    },
    readTime: "4 min read",
    likes: 298,
    url: "#",
    source: "CryptoPanic",
  },
  {
    id: 6,
    title: "Silver Market Shows Strong Demand from Industrial Sector",
    excerpt:
      "Industrial applications are driving increased demand for silver, affecting global commodity markets...",
    category: "Commodities",
    date: new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    image: "https://via.placeholder.com/400x250?text=Silver+News",
    author: {
      name: "Marketaux",
      avatar: "https://via.placeholder.com/40x40?text=MX",
      role: "Financial News",
    },
    readTime: "3 min read",
    likes: 134,
    url: "#",
    source: "Marketaux",
  },
];
